import React from 'react';
import { Image } from 'antd';
import { MessageQuestionIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { setQuestionId, setTestFeedbackModal } from 'modules/global';

import { MathJaxContext } from 'components';

export const Question = () => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const subjectName = useAppSelector(({ topicTest }) => topicTest.testInfo?.subject_name);
  const questions = useAppSelector(({ topicTest }) => topicTest.test?.test[0]?.questions);
  const currentQuestionIndex = useAppSelector(({ topicTest }) => topicTest.currentQuestionIndex);

  const question = questions?.[currentQuestionIndex as number];

  const onOpenFeedbackModal = () => {
    dispatch(setQuestionId(question?.question_id as number));
    dispatch(setTestFeedbackModal(true));
  };

  return (
    <div className="shadow-xs mb-3 rounded-xl bg-white px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="text-xs text-gray-500">
          {currentQuestionIndex + 1}/{(questions || [])?.length} • {subjectName}
        </div>
        <div onClick={onOpenFeedbackModal} className="flex cursor-pointer items-center gap-2 text-orange-400">
          <MessageQuestionIcon />
          <span className="text-sm">{t('xatolik_topdim')}</span>
        </div>
      </div>
      <div className="transition-all duration-300">
        <div className="text-md mt-3 font-medium whitespace-pre-line">
          <MathJaxContext expression={question?.question_name} />
        </div>
        {question?.image && (
          <div className="mt-4 flex justify-center">
            <Image
              src={question.image}
              alt={question?.question_name}
              loading="lazy"
              className="!rounded-xl"
              title="Test image"
            />
          </div>
        )}
      </div>
    </div>
  );
};
